import React from 'react';
import PropTypes from 'prop-types'
import axios from 'axios';
import { Route } from 'react-router-dom';
//component routes
import Login from '../routes/Login';
import Dashboard from '../routes/Dashboard';
import ResetPass from '../routes/ResetPass';
import Deactivate from '../routes/Deactivate';
import Recover from '../routes/Recover';
//containers
import SimpleContainer from './simplecontainer/SimpleContainer';
//config
const baseUrl = require('Config').baseUrl;

class Auth extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      logged: false,
      progress: 'Loading...',
      dashboard: null,
      token: null,
      firstName: '',
      key: '',
      hits: ''
    }
  }

  componentWillMount = () => {
    const token = localStorage.getItem('token');
    this.setState({ token });
    if(token){
      this.setState({logged: true});
      this.getUser(token);
    }
  }

  componentWillReceiveProps =(newProp) => {
    if(newProp.location.pathname === '/login' || newProp.location.pathname === '/login/'){
      if(this.state.logged){
        this.context.router.history.push('/dashboard');
      }
    }
  }

  getToken = (token) => {
    localStorage.setItem('token', token);
    this.setState({ token: token });
    this.getUser(this.state.token);
  }

  getUser = (token) => {

    // /*--- THIS SECTION NEEDS TO BE REMOVED ---*/
    // this.setState({
    //   progress: 'Success',
    //   logged: true,
    //   dashboard: true,
    //   firstName: 'Frederic',
    //   key: 'Fake key',
    //   hits: 900,
    //   monthlyHitsLimit: 1500,
    //   resetDate: '2019-03-19', // 'yyyy-mm-dd'
    // });

    // return;
    // /*------*/
    
    const url = `${baseUrl}/users/`;

    axios.get(url, {
      headers: {'x-logged-user': token }
    })
    .then((res)=>{
      let user = res.data.user_data; 
      this.setState({
        progress: 'Success',
        logged: true,
        dashboard: true,
        firstName: user.firstName,
        email: user.email,
        key: user.key,
        hits: user.api.monthly,
        monthlyHitsLimit: user.monthlyLimit,
        resetDate: new Date(user.cycle.resetDate).toISOString().split('T')[0],
      });
      //push user name to localstorage
      localStorage.setItem('name', user.firstName);
      //redirect to /dashboard
      this.context.router.history.push('/dashboard');
    })
    .catch((err)=>{
      this.setState({progress: 'Something went wrong, please try again later... '});
      console.log(err);
    });
  }

  render = () => {

    if(this.state.logged){
      if(!this.state.dashboard){
        return (
          <SimpleContainer color='dark' containerClass='header-container padded-container'>
            <h1>{this.state.progress}</h1>
          </SimpleContainer>
        );
      }
      else {
        return (
          <Dashboard user={{ 
            firstName: this.state.firstName, 
            email: this.state.email,
            key: this.state.key, 
            hits: this.state.hits, 
            monthlyHitsLimit: this.state.monthlyHitsLimit, 
            resetDate: this.state.resetDate }} ignoreScrollBehavior>
            <Route path='/dashboard/resetpass' component={ResetPass} />
            <Route path='/dashboard/deactivate' component={Deactivate} />
          </Dashboard>
        );
      }
    }
    else{
      return (
        <Login sendToken={this.getToken} ignoreScrollBehavior>
          <Route path='/login/recover' component={Recover} />
        </Login>
      );
    }
  }
};

Auth.contextTypes = {
  router: PropTypes.object.isRequired
}
export default Auth;



// WEBPACK FOOTER //
// ./src/containers/Auth.js